import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import {
  CONTACT_PAGE_URL,
  FAQ_PAGE_URL,
  HOME_PAGE_URL,
} from '../../utils/constants/Routes';
// Data
import {
  faqPageAdditionalMeta,
  faqPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import FaqPageMainContainer from '../../components/faq/FaqPageMainContainer';
// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import { Link } from 'react-router-dom';
import SocialMediaCtaComponent from '../../components/socialMedia/SocialMediaCtaComponent';

function FaqPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'FAQ', href: FAQ_PAGE_URL },
    ],
  });

  return (
    <>
      {/* SEO / Meta */}
      <HelmetItem
        PageName={`FAQ | ${CompanyName}`}
        desc={`Frequently asked questions about serving ${CompanyName}, tribute protocol, session requests, customs, and expectations.`}
        keywords={KeywordsPages}
        additionalMeta={faqPageAdditionalMeta}
        structuredData={[faqPageStructuredData, breadcrumbLd]}
        canonicalPath={FAQ_PAGE_URL}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-6 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Frequently asked questions about serving ${CompanyName}`}
              className='text-center font-titleFont text-4xl sm:text-5xl md:text-6xl tracking-widest'
            >
              Frequently Asked Questions
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>

            <div className='grid gap-y-4 pt-6 px-2'>
              <p className='text-center text-lg max-w-3xl mx-auto'>
                This page exists to answer the most common questions about
                approaching Me, tribute expectations, sessions, customs, and
                proper conduct.
                <br />
                <br />
                Read carefully. Most issues arise when instructions are ignored.
                Low-effort, disrespectful, or entitled behavior will not be
                entertained.
              </p>

              <p className='text-center text-base text-gray-300 max-w-3xl mx-auto'>
                If your question is answered here, do not ask it again. If it is
                not answered here, approach correctly through the{' '}
                <Link
                  href={CONTACT_PAGE_URL}
                  className='text-colour1 underline hover:text-colour1/80'
                >
                  Contact page
                </Link>
                .
              </p>
            </div>
          </header>

          {/* Main content */}
          <FaqPageMainContainer />
        </div>

        <SocialMediaCtaComponent />
      </div>
    </>
  );
}

export default FaqPage;
